import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1481. 見積タスクコメント欄に見積内容を記載して申請更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/update_quotation_in_comment
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  quotation_in_comment: boolean;
};

const updateQuotationInComment = (props: Props): Promise<QuotationTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.id}/update_quotation_in_comment`,
    props
  );
};

export const useUpdateQuotationInComment = () => {
  return useMutation({
    mutationFn: updateQuotationInComment,
  });
};
